export default (value: number) => {
    switch (value) {
        case 1:
            return "Gemini";
        default:
            return "Unknown";
    }
}
